module.exports = __webpack_public_path__ + "img/gracefinal.aa967622.png";